import React from "react";
import SuperviseTable from "../components/applications/table/supervisetable";
import { Link, useNavigate } from "react-router-dom";
import { Home, ChevronRight, ArrowLeft } from "lucide-react";

function SupervisionPage() {
  const navigate = useNavigate();

  return (
    <>
      <div className="w-full max-w-[95%] 2xl:max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <Link
              to="/dashboard"
              className="flex items-center hover:text-green-600 transition-colors"
            >
              <Home size={16} />
            </Link>
            <ChevronRight size={16} className="text-gray-300" />
            <span className="font-semibold text-gray-900">My Interns</span>
          </div>

          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-1 text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors"
          >
            <ArrowLeft size={16} /> Back
          </button>
        </div>
      </div>

      <div className="flex">
        <span className="relative m-auto mt-6 text-gray-500 font-semibold mb-2 text-sm lg:text-lg">
          Supervise & Assess Interns
        </span>
      </div>

      <main className="relative">
        <div className="flex space-x-4 m-auto">
          <SuperviseTable />
        </div>
        <div className="px-2 sm:px-2 lg:px-2 py-2 w-full max-w-9xl mx-auto"></div>
      </main>
    </>
  );
}

export default SupervisionPage;
